import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { type Control, useWatch } from "react-hook-form";

import type { FilterAndSorterFormTypes } from "@/dashboard/types";

export function useDebounceQueryFilter(control: Control<FilterAndSorterFormTypes>) {
  const query = useWatch({ control, name: "query" });
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  const debounceQueryValue = useMemo(
    () => debounce((value: FilterAndSorterFormTypes["query"]) => setDebouncedQuery(value), 250),
    [],
  );

  useEffect(() => {
    // lodash debounce is trailing by default; each call supersedes the previous pending call.
    debounceQueryValue(query);

    // Explicit cleanup avoids pending updates after unmount (and on dependency change).
    return () => {
      debounceQueryValue.cancel();
    };
  }, [query, debounceQueryValue]);

  return debouncedQuery;
}
